import React from 'react';
import { Autocomplete, TextField, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';
import RefreshIcon from '@mui/icons-material/Refresh';

const CustomAutoCompleteNew = React.forwardRef(
  ({
    options,
    value,
    onChange,
    disabled,
    error,
    helperText,
    onKeyDown,
    id,
    name,
    label,
    InputProps = {},
    endAdornment,
     variant = "filled",
    className = "custom-textfield",
    onAddClick,
    onRefreshClick,
    isRefreshing
  }, ref) => {

     const [focused, setFocused] = React.useState(false);
        const shouldShrink = !!value || focused;
    return (
      <Autocomplete
        id={id}
        options={options}
        getOptionLabel={(option) => option.Name || ''}
        value={value}
     
       
        onChange={(event, newValue) => {
          onChange({
            target: {
              name,
              value: newValue ? newValue.Id : ''
            }
          });
        }}
    
        popupIcon={undefined}
        clearOnBlur={false}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            variant={variant}
            className={className}
            size="small"
            // error={!!error}
            // helperText={helperText}
            inputRef={ref}
            onKeyDown={onKeyDown}
            InputProps={{
              ...params.InputProps,
              sx: {
                padding: '0', // Remove padding
                marginLeft: '0px !important', // Remove left margin
                paddingRight: "8px !important",
                paddingLeft: "8px !important"
              },
              
              startAdornment: (
                <>
                  {/* <InputAdornment position="start"  sx={{ marginRight: '0px' }}>
                    <SearchIcon color="action" />
                  </InputAdornment> */}
                  {params.InputProps.startAdornment}
                </>
              ),
              endAdornment: (
                <InputAdornment position="end">
              
                  {!disabled && (
                    <>
                      <AddIcon
                        onClick={onAddClick}
                        style={{ cursor: 'pointer', fontSize: '18px', color: '#2196f3' }} 
                      />
                      <RefreshIcon
                        onClick={onRefreshClick}
                        sx={{
                          fontSize: '18px',
                          color: '#4caf50',
                          cursor: 'pointer',
                          transition: 'transform 0.3s ease',
                          animation: isRefreshing ? 'spin 1s linear infinite' : 'none',
                          '@keyframes spin': {
                            '0%': {
                              transform: 'rotate(0deg)',
                            },
                            '100%': {
                              transform: 'rotate(360deg)',
                            },
                          },
                        }}
                      />
                    </>
                  )}
              
                </InputAdornment>
              ),
            }}
        //     fullWidth
        //     sx={{
        //       margin: 0, // Remove margin
        //       '& .MuiOutlinedInput-root': {
        //         padding: '0', // Remove padding from the input
        //         borderRadius: 1,
        //         backgroundColor: disabled ? 'action.disabledBackground' : 'background.paper',
        //       },
        //     }}
        //   />
        // )}
        InputLabelProps={{
          shrink: shouldShrink,
          sx: {
            transformOrigin: 'top left',
            ...(!shouldShrink && {
              transform: 'translate(14px, 18px) scale(1)',
              fontSize: '1rem'
            })
          }
        }}
        sx={{
          '& .MuiInputLabel-filled': {
            ...(!shouldShrink && {
              transform: 'translate(14px, 18px) scale(1)'
            })
          }
        }}
        fullWidth
      />
    )}
        disabled={disabled}
        // sx={{
        //   "& .MuiOutlinedInput-root": {
        //     borderRadius: 1,
        //     backgroundColor: disabled ? 'action.disabledBackground' : 'background.paper',
        //     margin: 0,
        //   }
        // }}
        sx={{
          "& .MuiAutocomplete-root": {
            backgroundColor: disabled ? 'action.disabledBackground' : 'background.paper'
          }
        }}
      />
    );
  }
);

export default CustomAutoCompleteNew;